// Dependencies
import axios from 'axios';

// Configuration
import { API_CONFIG } from './config';

// Interceptors
import { headersInterceptor, refreshTokenOnRejectedFn } from './interceptors';

/**
 * Create an axios instance
 */
const api = axios.create({
  baseURL: API_CONFIG.baseURL,
  timeout: API_CONFIG.timeout,
  headers: API_CONFIG.headers,
});

/**
 * Add the headers interceptor
 */
api.interceptors.request.use(headersInterceptor);

/**
 * Add a response interceptor to handle 401 errors and refresh the tokens
 */
api.interceptors.response.use((config) => config, refreshTokenOnRejectedFn(api));

/**
 * Export the axios instance
 */
export default api;
